import { inject, Injectable } from '@angular/core';
import { SiaHttpService } from '@sia/shared';
import { SiaGridFilterRequest } from '../interfaces/ai-filters';
import { SiaGridFile } from '../interfaces/grid-file';

@Injectable({
  providedIn: 'root',
})
export class SiaAIFilesApi {
  #aiController: string = 'ai-files-grid';

  #http = inject(SiaHttpService);

  retriveFiles(
    queryText: string | null | undefined,
    startIndex: number | undefined,
    endIndex: number | undefined,
    loadRelevantFiles: boolean | undefined,
    filesSha256ToExclude: string[] | undefined,
    categories: string[] | undefined,
    filters: SiaGridFilterRequest[] | undefined,
  ): Promise<{
    files: SiaGridFile[];
    totalCount: number;
    smartFilters: SiaGridFilterRequest[] | null;
    smartFiltersCategories: string[] | null;
  }> {
    if (!loadRelevantFiles) {
      return this.#http.post(`${this.#aiController}/page`, {
        queryText: queryText,
        startIndex: startIndex,
        endIndex: endIndex,
        categories: categories,
        filesSha256ToExclude: filesSha256ToExclude,
        filters: JSON.stringify(filters),
      });
    } else {
      return this.#http.post(`${this.#aiController}/relevant`, {
        queryText: queryText,
        categories: categories,
        filters: JSON.stringify(filters),
      });
    }
  }

  retrieveFileProperties(sha256: string): Promise<any> {
    return this.#http.get(
      `${this.#aiController}/extracted-properties/${sha256}`,
    );
  }


  retriveKeysFilterChips(categories: Set<string>) {
    return this.#http.post(`${this.#aiController}/keys-filter-chips`, {
      categories: Array.from(categories),
    });
  }
}
